<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.changelog.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineChangelogForm :APIbaseURL="APIbaseURL" :changelog="changelog" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineChangelogForm } from 'aveine-changelog';
import { Changelog } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      changelog: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Update',
  components: {
    AveineChangelogForm
  },
  async created() {
    try {
      await Changelog.api().get(`changelogs/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include: 'pictures',
          }
        }
      );
      this.changelog = await Changelog.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
